module.exports = __webpack_public_path__ + "static/media/software.6eed9468.svg";